import { Injectable, OnDestroy } from '@angular/core';
import { Router, NavigationEnd, NavigationStart } from '@angular/router';
import { ReferrerRouteService, ReferrerRouteParams } from './referrer-route.service';
import { filter, first, map } from 'rxjs/operators';

@Injectable()
export class SessionReferrerRouteService extends ReferrerRouteService implements OnDestroy {

  private referrerSubscription;

  constructor(router: Router) {
    super(router)
    const referrer = sessionStorage.getItem("referrer")
    if (referrer) {
      this.referrer$.next(referrer)
    }
    this.referrerSubscription = this.referrer$.subscribe((res)=>{
      sessionStorage.setItem("referrer", res)
    })
  }

  ngOnDestroy(): void {
    this.referrerSubscription.unsubscribe();
  }
}
